import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@stimulus/polyfills';
import 'custom-event-polyfill/polyfill';
import 'classlist-polyfill';

if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function removePolyfill() {
    if (this.parentNode) this.parentNode.removeChild(this);
  };
}

// converts low priority TTY styles provided by packs_view into
// normal stylesheets links, once the important content has been requested
function handlePreloadedStyles() {
  const preloadedStyles = document.querySelectorAll('link[data-preloaded-style]');
  preloadedStyles.forEach((style) => {
    const href = style.getAttribute('href');
    const currentStyle = document.querySelector(`link[href='${href}']`);
    if (currentStyle && currentStyle.getAttribute('media') !== 'tty') return false;

    const link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('media', 'screen');
    link.setAttribute('href', href);
    document.head.appendChild(link);

    return true;
  });
}

handlePreloadedStyles();
